import type {
  UserBadgeReputation,
  UserOnlineStatus,
} from 'generated/openapi/types.gen';
import type { ComponentProps } from 'react';
import { memo } from 'react';

import CrossedSwords from '@/assets/icons/crossed-swords.svg?react';
import { Badge, type BadgeProps } from '@/shared/components/ui/badge';
import { cn } from '@/shared/utils/cn';

import { ProfileBehaviorBadge } from '../profileBehaviorBadge';
import { ProfileStatusBadge } from '../profileStatusBadge';

export interface ProfileUserBadgesProps extends Omit<
  ComponentProps<'div'>,
  'children'
> {
  onlineStatus: UserOnlineStatus;
  isReadyToPlay: boolean;
  userId: string;
  reputationBadge?: UserBadgeReputation;
  badgeVariant?: BadgeProps['variant'];
  totalDuoGames?: number;
}

export const ProfileUserBadges = memo(function ProfileUserBadges(
  props: ProfileUserBadgesProps,
) {
  const {
    onlineStatus,
    isReadyToPlay,
    userId,
    reputationBadge,
    badgeVariant,
    totalDuoGames,
    className,
    ...rest
  } = props;

  return (
    <div className={cn('flex items-center gap-1', className)} {...rest}>
      {totalDuoGames !== undefined && totalDuoGames > 0 && (
        <Badge variant={badgeVariant}>
          <CrossedSwords className="size-4" />
          {totalDuoGames} Duo games
        </Badge>
      )}
      {reputationBadge && (
        <ProfileBehaviorBadge
          reputationBadge={reputationBadge}
          badgeVariant={badgeVariant}
        />
      )}
      <ProfileStatusBadge
        onlineStatus={onlineStatus}
        isReadyToPlay={isReadyToPlay}
        userId={userId}
        badgeVariant={badgeVariant}
      />
    </div>
  );
});
